import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from '../authentication.service';
import {Router} from '@angular/router';

declare var $: any;
declare var Nanobar: any;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})

export class NavbarComponent implements OnInit {
  get user(): any {
    return localStorage.getItem('displayName');
  }
  nao = new Nanobar();
  userData: any;
  userSuccess: any;
  constructor(private authService: AuthenticationService, private router: Router) { }
logoutFunction() {
    this.nao.go(30);
              window.localStorage.setItem('isauthenticated', 'false');
              // window.localStorage.setItem('token', '');
              window.localStorage.setItem('displayName', '');
              window.localStorage.setItem('userRoles', '');
    this.authService.logout(window.localStorage.getItem('token')).subscribe(
      (data) => {
        console.log('login data', data);
        this.nao.go(100);
        this.userData = data;
        this.userSuccess = this.userData.success;
        // if (this.userSuccess === true) {
        // console.log('logout chk', this.userSuccess);
              this.router.navigate(['']);
        // }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  ngOnInit() {
    // $('#user').on('keyup', function() {
    //   var input = $(this);
    //   if(input.val().length === 0) {
    //     input.addClass('empty');
    //   } else {
    //     input.removeClass('empty');
    //   }
    // });
  }

}



// WEBPACK FOOTER //
// ./src/app/navbar/navbar.component.ts